/**
 * Format phone number to XXX-XXX-XXXX format
 * @param {string} value - The input value
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/[^\d]/g, '');
  
  // Get length of phone number
  const phoneNumberLength = phoneNumber.length;
  
  // Format based on length
  if (phoneNumberLength < 4) return phoneNumber;
  
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Validate phone number format
 * @param {string} phone - The phone number to validate
 * @returns {boolean} - True if valid format
 */
export const isValidPhoneNumber = (phone) => {
  if (!phone) return true; // Phone is optional
  
  // Remove formatting
  const digits = phone.replace(/[^\d]/g, '');
  
  // Should be exactly 10 digits
  return digits.length === 10;
};
